
export var ratings = {};

export function getSelfRatings(){
    const inputs = $(".self-input");
    inputs.each((ind, obj) => {
        const inputId = $(obj).attr('data-inputid');
        const taskId = $(obj).parents(".tab").attr('data-aufgabe');

        const value = parseFloat($(obj).val());

        if (ratings[taskId] == undefined){
            ratings[taskId] = {}
        }
        
        if (ratings[taskId][inputId] == undefined){
            ratings[taskId][inputId] = {}
        }

        ratings[taskId][inputId] = {"right": value};
    });

    
    return ratings;
}